
export function footer1_viewportEnter(event) {
$w('#group6').show()
}